import { PostHog } from "posthog-node";

export const getPostHogClient = (
  apiKey: string,
  host: string = "https://us.i.posthog.com",
): PostHog => {
  const posthog = new PostHog(apiKey, {
    host,
    enableExceptionAutocapture: true,
  });

  return posthog;
};
